import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { Activity, ActivityDeviationStatus } from '@wilson/interfaces';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TimeLineActivityTooltipComponent } from '@wilson/shift-timeline/assignments-gantt-chart';
import { ActivityCardContentComponent } from '@wilson/shift-timeline/core';

@Component({
  selector: 'wilson-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NzTooltipModule,
    TimeLineActivityTooltipComponent,
    ActivityCardContentComponent,
  ],
})
export class ActivityCardComponent {
  @Input({ required: true }) activity!: Activity;
  @Input() leftPx!: number | null;
  @Input() rightPx!: number | null;
  @Input() calculatedActivityWidth!: number | null;
  @Input() accurateActivityStartDateTime!: string;
  @Input() activityStartTimeDifference!: number;
  @Input() accurateActivityEndDateTime!: string;
  @Input() activityEndTimeDifference!: number;
  @Input() activityStartTimeType!: ActivityDeviationStatus;
  @Input() activityEndTimeType!: ActivityDeviationStatus;
  @Input() dottedBorder = false;
  @Input() isHovered = false;

  isTooltipVisible = signal(true);
}
